import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import { getApiCall, deleteApiCall } from "../../../service/httpCall";
import { API_TTS_LIST, API_TTS_DELETE } from "../../../service/url";
import { useAuth, errorCheck } from "../auth/auth-utils";
import ToastNotification from "../../../components/Toast";
import Loader from "../../../components/partials/components/loader";
import { toast } from 'react-toastify';
import exportData from "../../../utilities/export";
import { getUser } from "../../../utilities/setting";
import { USER_ROLES, MODULE_ACL } from '../../../utilities/constant';


const TtsList = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [webhookToDelete, setWebhookToDelete] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [webhooksData, setWebhooksData] = useState([]);
  const [userRole, setUserRole] = useState(undefined);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  const [isSuperAdmin, setIsSuperadmin] = useState(false)

  useEffect(() => {
    getUser().then((resp) => {
      if (resp) {
        setUserRole(resp.role);
      }
         if (resp.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (resp?.acl_settings) {
            setLoggedInUserACL(JSON.parse(resp.acl_settings.module_operations));
         }
    });
  }, []);

  //  Fetch list
  useEffect(() => {
    setLoading(true);
    getApiCall(API_TTS_LIST, {})
      .then(onListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
  }, []);
  const handleExport = async () => {
    setButtonDisable(true);
    await exportData("TTS", setToastProps, setShowToast);
    setButtonDisable(false);
  };

  const onListSuccess = (resp) => {
    setWebhooksData(resp);
  };

  const onError = (err) => {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
      toast.error(err)
    } else {
      console.log(err);
    }
  };

  //   Delete TTS
  const confirmDelete = async () => {
    const url = API_TTS_DELETE.replace(":id", webhookToDelete);
    await deleteApiCall(url).then(onDeleteSuccess).catch(onDeleteError);
    setShowDeleteModal(false);
    setWebhookToDelete(null);
  };

  const onDeleteSuccess = (resp) => {
    toast.success("TTS deleted successfully")
    getApiCall(API_TTS_LIST, {}).then(onListSuccess).catch(onError);
  };

  const onDeleteError = (err) => {
    toast.error(JSON.stringify(err))
  };

  const actionBodyTemplate = (rowData) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {(isSuperAdmin || loggedInUserACL[MODULE_ACL.TTS]?.delete) && (
        <FiTrash2
          style={{ color: "#dc3545", cursor: "pointer" }}
          onClick={() => handleAction("delete", rowData.id)}
        />
      )}
    </div>
  );

  const handleAction = (action, id) => {
    if (action === "delete") {
      setWebhookToDelete(id);
      setShowDeleteModal(true);
    }
  };

  const filteredWebhooks = webhooksData?.filter((item) =>
    item?.file_name?.toLowerCase()?.includes(searchValue?.toLowerCase())
  );

  if (loading) return <Loader />;

  return (
    <>
      <div className="webhooks-container">
        <Row>
          <Col sm="12">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-0">
                <div className="header-title px-4 py-3 d-flex justify-content-between align-items-center">
                  <h4 className="card-title m-0">TTS LIST</h4>
                  <div className="d-flex gap-3">
                    {webhooksData.length > 0 && (
                      <Button
                        label="Export Data"
                        icon="pi pi-file-export"
                        onClick={handleExport}
                        className="p-button-active"
                        style={{ paddingLeft: "20px" }}
                        disabled={buttonDisable}
                      >
                        Export Data &nbsp;
                        {buttonDisable && (
                          <span
                            className="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                    )}
                  </div>
                </div>

                <div className="px-4 py-3">
                  <Form className="d-flex align-items-center">
                    <Form.Control
                      placeholder="Search TTS..."
                      type="text"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      style={{ maxWidth: "250px" }}
                    />
                  </Form>
                </div>

                <div className="pb-4">
                  <div
                    style={{ overflowX: "auto" }}
                    className="broad-scrollbar"
                  >
                    <DataTable
                      value={filteredWebhooks}
                      scrollable
                      tableStyle={{ minWidth: "100%" }}
                      paginator
                      rows={12}
                    >
                      <Column field="id" header="TTS Id" />
                      <Column field="tts_creator.username" header="Username" />
                      <Column field="language" header="Language" />
                      <Column field="gender" header="Gender" />
                      <Column
                        field="file_name"
                        header="File Name"
                        style={{ minWidth: "200px" }}
                      />
                      <Column
                        field="text_script"
                        header="Text Script"
                        style={{ minWidth: "200px" }}
                      />
                      <Column field="character_count" header="Total Length" />
                      <Column
                        field="req_date"
                        header="Request Date"
                        body={(rowData) =>
                          new Date(rowData?.req_date).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })
                        }
                      />
                      {userRole === USER_ROLES.SUPERADMIN && (
                        <Column
                          field="status"
                          header="Status"
                          body={(rowData) => {
                            if (rowData?.tts_prompt?.prompt_status == "0") {
                              return "Pending"
                            } else if (rowData?.tts_prompt?.prompt_status == "1") {
                              return "Approved"
                            } else {
                              return "Rejected"
                            }
                          }}
                        />
                      )}
                      <Column field="category" header="Category" />
                      <Column
                        field="deleted_date"
                        header="Deleted Date"
                        body={(rowData) =>
                          new Date(rowData?.deleted_date).toLocaleString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            }
                          )
                        }
                      />
                      <Column
                        field="tts_deleted_details.username"
                        header="Deleted By"
                      />
                      <Column header="Action" body={actionBodyTemplate} />
                      {}
                    </DataTable>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Delete Modal */}
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this tts? This action cannot be
            undone.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      />
      <style>
        {`
  .broad-scrollbar::-webkit-scrollbar {
    height: 8px; 
  }
`}
      </style>
    </>
  );
};

export default TtsList;
